<template>
    <div>      
        <div ref="picker" v-bind:id="id"></div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import colorPicker from 'tui-color-picker';
    import guidMixin from '../../Util/Mixins/guid';
    
    export default {
        name: "color-picker",
        mixins: [guidMixin],
        created (){
            this.id = this.guid();
        },
        mounted () {
            const vm = this;
            const picker = vm.$refs.picker;

            const colorpicker = colorPicker.create({
                container: picker,
                color: vm.color,
                defaultColor: '#f8f8f8',
                preset: ['#f8f8f8','#DABFB9','#B59471','#C35075','#D98775','#C3A995','#E5F2C9','#7F534B','#AB947E','#6F5E53','#919098','#897C80','#BA8F95','#CAB6CD','#CFBCDF','#000000'],
                
                //https://github.com/nhn/tui.color-picker#collect-statistics-on-the-use-of-open-source
                usageStatistics: false
            });

            vm.container = $(colorpicker.options.container);

            colorpicker.on('selectColor', function(obj) {
                vm.$emit('set-last-color', vm.color);
                vm.$emit('change-color', obj.color);
            });
        },
        watch: {
            color(value) {
                this.container.find('input[type="text"]').val(value);
            }
        },
        computed: {
            style() {
                const rules = [
                    'background-color: ' + this.color,
                    'cursor: ' + (this.enabled ? 'pointer' : 'default')
                ];

                return rules.join(';');
            }
        },
        data() {
            return {
                id: null,
                container: null
            }
        },
        props: {
            color: {
                type: String,
                required: true
            },
            enabled: {
                type: Boolean,
                default: true
            },
            lastColor: {
                type: String,
                default: '#ffffff'
            }
        }
    }
</script>

<style src="tui-color-picker\dist\tui-color-picker.css"></style>

<style scoped>

.hidden {
    display: none;
}

.preview {
    width: 80px;
    height: 30px;
    border: 1px dashed gray;
    text-align: center;
}

</style>